import styled from "styled-components";

export const Container = styled.div`
  padding: 0.5rem;
  width: 100%;
  overflow-y: auto;

  @media (min-width: 768px) {
    padding: 1rem;
  }
`;
